
import List from '@material-ui/core/List'

import { TicketListItemNotifications } from '../TicketListItemNotifications'

import { useStyles } from './style'

// const defaultLogoFavicon = '/vector/favicon.svg'

const NotificationsPopOver = ({ notifications, volume, onClose }) => {
  const classes = useStyles()
  // const [isOpen, setIsOpen] = useState(false)

  const NotificationTicket = ({ children }) => (
    <div
      className={classes.notificationTicket}
      onClick={() => onClose && onClose()}
    >
      {children}
    </div>
  )

  return (
    <List component="nav" className={classes.chatContainer}>
      {notifications.map(ticket => (
        <NotificationTicket key={ticket.id}>
          <TicketListItemNotifications
            ticket={ticket}
            groupActionButtons={true}
          />
        </NotificationTicket>
      ))}
    </List>
  )
}

export default NotificationsPopOver
